export default {
    admin: 'admin',
    general: 'general',
  };